import * as navigation from 'Navigation';

export default class ComplexPolymerComponentsTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Polymer Components',
      closeable: false,
      preferenceKey: 'complex-polymer-components',
    };
  }
}
